import cn from 'classnames';
import { useState } from 'react';

import s from './EditableBlock.module.scss';

type Props = {
  /** Что правим — для экранного диктора */
  label: string;
  disabled: boolean;
  children: React.ReactNode;
  renderEditor: (close: () => void) => React.ReactNode;
};

/** Название и описание: при наведении — рамка, клик открывает редактор. Ссылки и выделение текста не мешают */
const EditableBlock: React.FC<Props> = ({ label, disabled, children, renderEditor }) => {
  const [isEditing, setIsEditing] = useState(false);
  const close = () => setIsEditing(false);

  if (isEditing) {
    return (
      <div
        // Esc отменяет правку, а не закрывает всю карточку
        onKeyDown={(event) => {
          if (event.key !== 'Escape') return;

          event.stopPropagation();
          close();
        }}
      >
        {renderEditor(close)}
      </div>
    );
  }

  const open = (event: React.MouseEvent) => {
    const isSelectingText = !!window.getSelection()?.toString();

    if (disabled || isSelectingText || (event.target as HTMLElement).closest('a')) return;

    setIsEditing(true);
  };

  return (
    <div
      className={cn(s.block, !disabled && s.block_editable)}
      role={disabled ? undefined : 'button'}
      tabIndex={disabled ? undefined : 0}
      aria-label={disabled ? undefined : `Изменить ${label}`}
      onClick={open}
      onKeyDown={(event) => {
        if (disabled || event.target !== event.currentTarget || event.key !== 'Enter') return;

        event.preventDefault();
        setIsEditing(true);
      }}
    >
      {children}
    </div>
  );
};

export { EditableBlock };
